import Dropdown from "./dropdown_controller"

export default class extends Dropdown {
  static values = {
    markReadUrl: String
  }

  open() {
    super.open()
    this.markAllAsRead()
  }

  markAllAsRead() {
    if (!this.hasMarkReadUrlValue) return

    fetch(this.markReadUrlValue, {
      method: "POST",
      headers: {
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content,
        "Accept": "application/json"
      }
    }).then((response) => {
      if (!response.ok) return
      this.clearUnreadBadges()
      this.clearUnreadDropdownItems()
    })
  }

  clearUnreadBadges() {
    document.querySelectorAll("[data-notifications-unread-badge]").forEach((badge) => {
      badge.textContent = "0"
      badge.classList.add("hidden")
    })
  }

  clearUnreadDropdownItems() {
    this.element.querySelectorAll("[data-notification-unread]").forEach((item) => {
      item.removeAttribute("data-notification-unread")
      item.classList.remove("bg-blue-50/50")
    })
  }
}
